<template>
<div class="chapter">
<div class="inner_page">
<p class="img" id="map1"><img alt="image" height="800" src="images/Map_1_fmt.jpeg" width="538"/></p>
<p class="img" id="map2"><img alt="image" height="800" src="images/Map_2_fmt.jpeg" width="541"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map1.vue?03e5f9bc